<template>
    <div class="page">
        <the-header />
        <div class="body">
            <div class="wrapper">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import TheHeader from '../components/TheHeader.vue'
export default {
  components: { TheHeader },

}
</script>

<style lang="less">
.page{
    display: flex;
    flex-direction: column;
    height: 100%;
    .body{
        padding-top: 40px;
        flex:1 1 auto;
        background-color: white;
    }
}
</style>